import React, { FC } from 'react'
import { useReactiveVar } from '@apollo/client'

import { ProjectFeed } from 'modules/Feed/components'
import { useProjectFeed } from '../serviceHooks'
import { ConditionRender, LoadMore, NoItems } from 'components'
import { AddNewStory } from './index'
import { FilterProjectDetails } from 'modulesCommon/Filters/containers'
import { SkeletonStories } from 'modulesCommon/Skeleton/ProjectDetails'
import { spaceIdVar } from 'modulesCommon/store'
import { useTags } from 'modulesCommon/Tags/useTags'
import { LocalStory } from '../../../components/Story/containers/LocalStory'
import { LocalizedProjectStory } from 'components/Story/containers/LocalizedProjectStory'
import { useLocalProjectFlags } from '../../../modulesCommon/serviceHooks'

const ProjectFeedContainer: FC<{ isLocalizing?: boolean }> = ({ isLocalizing = false }) => {
  const {
    activeProject,
    projectFeed,
    country,
    factSourcesList,
    increaseFeedOffset,
    projectFeedTotal,
    feedLoading,
    isFeedLoaded,
    currentLabelId
  } = useProjectFeed()
  const spaceId = useReactiveVar(spaceIdVar)
  const { tags } = useTags({ labelId: currentLabelId, spaceId })
  const { isLocalized } = useLocalProjectFlags(activeProject)

  return (
    <>
      <ConditionRender
        condition={!isLocalizing}
        component={
          <div className="sbx-row" style={{ alignItems: 'center', justifyContent: 'space-between' }}>
            <AddNewStory isFeedPage={false}>
              <FilterProjectDetails />
            </AddNewStory>
          </div>
        }
      />
      <ConditionRender
        condition={!!projectFeed.length}
        component={
          <>
            <ProjectFeed
              feed={projectFeed as any[]}
              country={country}
              factSources={factSourcesList}
              storyItem={(story, extra) => {
                return isLocalized ? (
                  <LocalizedProjectStory
                    story={story}
                    tagsList={tags}
                    handleModal={extra.handleModal}
                  />
                ) : (
                  <LocalStory
                    story={story}
                    tagsList={tags}
                    handleModal={extra.handleModal}
                  />
                )
              }}
            />
            <LoadMore
              label="stories"
              onLoad={increaseFeedOffset}
              isItemsLoading={feedLoading}
              itemsTotal={projectFeedTotal}
              itemsCount={projectFeed.length}
            />
          </>
        }
        secondComponent={isFeedLoaded ? <NoItems name="Stories" /> : <SkeletonStories />}
      />
    </>
  )
}

export default ProjectFeedContainer
